import React, { useEffect, useRef, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Procced from "../Procced/component";
import coupon2 from "../../assets/coupon1.png";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import loginBackground from "../../assets/loginBackground.png";
import keypad from "../../assets/keypad.png";
import otpkeyicon from "../../assets/otpkeyicon.png";
import proArrow from "../../assets/proArrow.png";
import changeArrow from "../../assets/changeArrow.png";
import { mpAddItemintoCart, mpClick } from "../../Mixpanel";
import bpPg from '../../assets/bpPg.png'
import dpPg from '../../assets/dpPg.png'
import pluxee from '../../assets/plx-logo.svg'
import "../Mycart/mycart.css";
import MyCartHeader from "../../components/Header/MyCartHeader";
import WaitingLoder from "../WaitingLoader/component";
import { Box, Typography } from "@material-ui/core";
import paytm from '../../assets/Paytm.png'
import r_card from '../../assets/r_card.png'
import card from '../../assets/card.png'

import GooglePopupSumbitOtpContainer from "../Google_Popup_Submit_otp/container";
import GoogleLogin from "react-google-login";

const image_base_url = "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/";

function Mycart(props) {


  const handleReload = () => {
    localStorage.setItem("defaultPgId",9);
    localStorage.setItem("defaultPgName","WALLET_LOYALTY");
    localStorage.removeItem("google_jwt")
    setTimeout(() => {
      window.location.reload();
    }, 200);
    // Reloads the current page
  };
  const inputRef = useRef(null); 
  const inputOtpRef = useRef(null); 
  const handleNumber = (e) => {
    props&&props.setNumber(e.target.value);
    console.log(e.target.value) // Update state with the input value
  };

  const handleOtp = (e) => {
    props&&props.setOtp(e.target.value);
    console.log(e.target.value) // Update state with the input value
  };

  console.log("props&&props.otp",props&&props.otp)

  useEffect(() => {
    if (inputOtpRef.current) {
      inputOtpRef.current.focus(); // Automatically focus on the input field
    }
  }, [props&&props.otp]); 
  // Keep focus on the input field after re-renders
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus(); // Automatically focus on the input field
    }
  }, [props&&props.number]); // Dependency ensures this runs after state updates

  console.log("couponReward")
  const finalDiscount = props && props.couponAppled && props.couponAppled.reward.count
  useEffect(() => {}, [props.couponAppled])
  const finalAmountGrand = finalDiscount ? props && props.totalAmount && props.totalAmount - finalDiscount : props && props.totalAmount

  const finalAmountGrandDiscount = finalAmountGrand && finalAmountGrand - (props && props.couponReward && props && props.couponReward.count);

  console.log("props&&props.appliedCouponData&&props.appliedCouponData.data.reward.count", props && props.appliedCouponData)
  const x = 45
  let v = x.toFixed(2);
  console.log(" float", v);
  console.log("props.clientId", props.clientId);
  const navigate = useNavigate();
  const [myCart, setMyCart] = useState(localStorage.getItem("mycart"));
  const defaultPgName = localStorage.getItem("defaultPgName");
  const machineId = localStorage.getItem("machineId");
 
  const [timeLeft, setTimeLeft] = useState(30); // Initial timer value
  const [canResend, setCanResend] = useState(false);
  //console.log("couponTotalReward",couponTotalReward&&couponTotalReward.data.data.reward.count)
  //const mycart=


  const ComboData = props && props.comboList && props.comboList[0] && props.comboList.map((p) => {

    console.log("ComboData", (p.id) == (props && props.comboCart && props.comboCart.id))

    if ((p.id) == (props && props.comboCart && props.comboCart.id)) {
      console.log("ComboData if ", props && props.comboCart)

      //setTotalAmount(totalamount+p.offer_price)


      return { ...p, mycount: props && props.comboCart && props.comboCart.count };
    }
    return p;
  });

  console.log("combodata--->", ComboData)


  const ComboComponent = ({ data }) => {


    return (
      <>
        <Box>

          <Box
            className="styles_slider__podEu"
            data-testid="grid-slider"
            style={{ marginTop: "10px", padding: "3%" }}
          >




            <Box

              marginBottom={"5%"}
              boxShadow={"0px 4px 10px 0px rgba(56, 79, 111, 0.12)"}

              borderRadius={"16px"}
              width={"100%"}

              style={{ background: "white" }}

            >


              <Box margin={"10px"}>
                <Box

                >
                  <Box
                    className="styles_ImageContainer__2rk9a"

                    style={{
                      background: "rgb(255, 255, 255)",
                      height: "129px",
                      width: "114px",
                      "margin-bottom": "11px"
                    }}
                  >
                    <img
                      className="styles_Image__1fplJ"
                      loading="lazy"

                      src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${props && props.comboCart && props.comboCart.imageUrl}`}
                    />
                  </Box>

                </Box>
                <Box

                  className="styles_containerRestaurant__3vhx3"
                  style={{ padding: "12px!important" }}
                >
                  <div
                    className="styles_containerImageBadge__14fk3"
                    style={{ fontFamily: "Roboto" }}
                  >
                    <div
                      data-testid="resturant-card-name"
                      className="styles_restaurantName__29jAP"
                      style={{ fontSize: "14px", marginTop: "10px" }}
                    >
                      <TruncatedVmname
                        text={props && props.comboCart && props.comboCart.name}

                        limit={25}

                      />
                    </div>
                    {/*          <div
                              style={{ color: "#94A3B8", fontSize: "12px",marginRight:"8px" }}
                            >
                              Tray <TruncatedTray text={el&&el.slot_id&&el.slot_id.toString()} limit={1}/>
                            </div> */}
                  </div>

                  <div

                    style={{}}
                  >
                    <span
                      data-testid="restaurant-card-cuisines"
                      style={{
                        fontSize: "12px",
                        color: "rgba(148, 163, 184, 1)",
                        fontFamily: "Roboto",



                        "font-style": "normal",
                        "font-weight": "400",
                        "line-height": "20px",
                      }}
                    >
                      <span style={{ visibility: "" }}><TruncatedDescription text={props && props.comboCart && props.comboCart.description} limit={25} /></span>
                      {/*                             <Typography fontSize={"12px"} style={{color:"rgba(113, 129, 152, 1)"}}>{el.activeCount>0&&<span>{el.activeCount}{" "}Left</span>}</Typography>
 */}                            </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      "margin-top": "42px",
                    }}
                  >
                    <h2 className="Real-Rs"
                      style={{
                        
                        
                      }}
                    >
                                            Rs.{""} {((props && props.comboCart && props.comboCart.totalPrice && props.comboCart.totalPrice) * (props && props.comboCart && props.comboCart && props.comboCart.count)).toFixed(2)}

                    </h2>
                    <h2
                      style={{
                        color: "#718198",
                        "text-align": "right",
                        /* SM14 */
                        "font-family": "Roboto",
                        "font-size": "10px",
                        "font-style": "normal",
                        "font-weight": "600",
                        "line-height": "150%",/* 21px */
                        "letter-spacing": "0.2px",
                        "marginLeft":"-10px",
                        "text-decoration": "line-through"
                      }}
                    >
                      ₹{""} {((props && props.comboCart && props.comboCart.actualPrice && props.comboCart.actualPrice) * (props && props.comboCart && props.comboCart && props.comboCart.count)).toFixed(2)}

                    </h2>

                    {



                      <div className="addToCartBtn"
                        style={{
                        

                        }}
                      >
                        <h3
                          onClick={(e) => {
                            props.ComboCartRemove(
                              e,

                              props && props.comboCart && props.comboCart.count,
                              props && props.comboCart && props.comboCart.id
                            );
                          }}
                        >
                          -
                        </h3>

                        {props && props.comboCart && props.comboCart.count}

                        <h3
                          onClick={(e) => {
                            props.ComboCartADD(
                              e,

                              props && props.comboCart && props.comboCart.count,
                              props && props.comboCart && props.comboCart.id
                            );
                          }}
                        >
                          +
                        </h3>
                      </div>



                    }
                  </div>
                </Box>
              </Box>

              <div />

            </Box>




          </Box>
        </Box>
        <>



        </>

      </>



    );
  };

  useEffect(() => {

    console.log("Paste OTp", props.otp)
  }, [props.otp])

  useEffect(() => {

    if (props.itemsList && props.itemsList[0] && props && props.flagMp) {
      mpAddItemintoCart({ EventName: "Add_more_items", data: { Number_of_Items: props && props.itemsList && props.itemsList.length, CartValue: finalAmountGrand } })
      props.setFlagMp(false)
    }
  }, [props.itemsList && props.itemsList])
  useEffect(() => {

    console.log("window.innerHeight", window.innerHeight, myCart);
    mpClick({ EventName: "Cart_page_opened" })

  }, []);





  const completeOrder = (e, finalAmount) => {
    console.log("khan Balance Condition", props.distotalAmount, props.totalAmount, props.paymentOptionsList[3].balance, finalAmount, props &&
      props.paymentOptionsList[3].balance >=
      (props.distotalAmount ? props.distotalAmount : props.totalAmount));
    console.log("props&&props.discountedAmount", props && props.distotalAmount)
    const defaultPgId = localStorage.getItem("defaultPgId");
    console.log("khan defaultPgId",defaultPgId)

    if (!(props && props.comboCart && props.comboCart == null)) {
      if (finalAmountGrand) {
        if (props && props.couponReward && props.couponReward.type == "freegift") {
          localStorage.setItem("finalAmount", finalAmountGrand)
        }
        if (props && props.couponReward && props.couponReward.type == "cashback") {
          localStorage.setItem("finalAmount", finalAmountGrand)
        }
        if (props && props.couponReward && props.couponReward.type == "discount") {
          localStorage.setItem("finalAmount", finalAmount)
        }
        if (!(props && props.couponReward && props.couponReward.type)) {
          localStorage.setItem("finalAmount", finalAmountGrand)
        }
      }
      else (
        localStorage.setItem("finalAmount", (props && props.comboCart && props.comboCart.totalPrice) * (props && props.comboCart && props.comboCart.count))

      )
    }



    if (props && props.paymentOptionsList[2].pgId == defaultPgId) {
      console.log("Balance Condition", props.distotalAmount, props.totalAmount, props &&
        props.paymentOptionsList[2].balance >=
        (props.distotalAmount ? props.distotalAmount : props.totalAmount));
      if (
        props &&
        props.paymentOptionsList[2].balance >=
        (props.distotalAmount ? finalAmount : props.totalAmount)
      ) {

        if (!(props && props.paymentOptionsList[2].reason)) {
          props.CreateOrderapi();
          console.log("completeOrder", props.distotalAmount, props.totalAmount);
        }
        else {
          toast.error(`Business Payments Not Allow`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
        }
      } else {
        console.log("Business payments Low Balance");
        toast.error(`Business payments Low Balance`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }
    }

    if (props && props.paymentOptionsList[3].pgId == defaultPgId) {
      console.log("completeOrder", props.distotalAmount, props.totalAmount);
      if (
        props &&
        props.paymentOptionsList[3].balance >=
        (props.distotalAmount ? props.distotalAmount : props.totalAmount)
      ) {
        console.log("completeOrder", props.distotalAmount, props.totalAmount);
        props.CreateOrderapi();
      } else {
        console.log("DaalChini  Low Balance");
        toast.error(`DaalChini Points Low `, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }
    }

    if (
      props.paymentOptionsList[1].pgId == defaultPgId ||
      props.paymentOptionsList[1].pgId == defaultPgId ||
      props.paymentOptionsList[5].pgId == defaultPgId
    ) {
      props.CreateOrderapi();
    }

    if (props && props.paymentOptionsList[0].pgId == defaultPgId) {
      console.log("completeOrder", props.distotalAmount, props.totalAmount);
      if (
        props &&
        props.paymentOptionsList[0].balance >=
        (props.distotalAmount ? props.distotalAmount : props.totalAmount)
      ) {
        console.log("completeOrder", props.distotalAmount, props.totalAmount);
        props.CreateOrderapi();
      } else {
        console.log("Low Paytm Balance");
        toast.error(`Low Paytm Balance`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }
    }
  };


  const [cartFlag, setCartFlag] = useState(true);
  useEffect(() => {
    setCartFlag(localStorage.getItem("mycart"));

    if (!localStorage.getItem("mycart")) {
      console.log("props Mycart props Mycart");
      // navigate("/");
    }

    calculateTotalAmount();
  }, []);

  const calculateTotalAmount = () => {
    const amount =
      props.itemsList &&
      props.itemsList.reduce(
        (total, stageuct) =>
          // console.log("totalamounttotalamount",total,stageuct.count,stageuct.mrp)
          total + stageuct.amount * stageuct.count * 6
      );
    console.log("props amount", amount);
  };
  console.log("props Mycart", cartFlag);
  let list = false;
  if (props.itemsList) {
    console.log("props ItemCard props ItemCard", props.itemsList);
    list = props.itemsList;
    if (!list[0]) {
      navigate(`/items?machineId=${machineId}`, { replace: true });
    }
    if (!list[0] && cartFlag) {
      navigate(`/items?machineId=${machineId}`, { replace: true });
    }
  }
  function TruncatedVmname({ text, limit }) {
    if (text && text.length <= limit) {
      return <span style={{ fontSize: "14px", color: "#384F6F" }}>{text}</span>;
    }
    return (
      <span style={{ fontSize: "14px", color: "#384F6F" }}>{`${text && text.substring(
        0,
        limit
      )}`}</span>
    );
  }
  function TruncatedDescription({ text, limit }) {
    if (text && text.length <= limit) {
      return (
        <

          >
          {text}
        </>
      );
    }
    return (
      <>{`${text && text.substring(0, limit)}...`}</>
    );
  }
  function TruncatedTray({ text, limit }) {
    if (text && text.length <= limit) {
      return (
        <

          >
          {text}
        </>
      );
    }
    return (
      <>{`${text.substring(0, limit)}`}</>
    );
  }

  const AddGoogleNumber=()=>{
  
    return(<>
    
  
      { <div className="modal">
        
          
          <div style={{display:"flex",justifyContent:"center"}}>
        <div style={{padding:"5%",marginTop:"20%",    width: "90%"}}>
  
              <div style={{background:"white",widows:"100%" ,height:"80vw",borderRadius:"10px"}}>
  
              <div style={{display:"flex",justifyContent:"center",position: "relative",
    top:"-70px"}}><svg style={{    width: "90px"}} xmlns="http://www.w3.org/2000/svg" width="124" height="124" viewBox="0 0 124 124" fill="none">
  <g clip-path="url(#clip0_83_382)">
  <path d="M79.4837 103.027C102.384 93.125 112.921 66.5329 103.019 43.6324C93.1164 20.732 66.5243 10.195 43.6238 20.0974C20.7233 29.9998 10.1863 56.5919 20.0888 79.4924C29.9912 102.393 56.5832 112.93 79.4837 103.027Z" fill="#009846"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M45.9086 38.8813L53.7773 45.6473C53.7773 45.6473 55.6852 47.8822 54.5372 49.9086C48.2219 61.1602 65.447 75.9554 75.6141 68.0047C77.4648 66.569 79.9435 68.1099 79.9435 68.1099L87.8122 74.8758C93.2011 78.9009 80.8114 88.1892 71.4763 84.9996C62.749 82.018 54.1075 74.0091 53.012 72.9999C51.8431 72.0931 42.6223 64.7585 38.3547 56.5766C33.7987 47.8368 41.0905 34.1622 45.8888 38.8899L45.9086 38.8813Z" fill="#FEFEFE"/>
  </g>
  <defs>
  <clipPath id="clip0_83_382">
  <rect width="93.6566" height="93.6566" fill="white" transform="translate(0 37.1719) rotate(-23.3842)"/>
  </clipPath>
  </defs>
  </svg></div>
  
  <div style={{position:"relative",top:"-91px",textAlign:"center",padding:"0%"}}>
  
  
  
  <h1 style={{fontSize:"16px",fontWeight:"700"}}>Verify Your Number</h1>
  <div style={{display:"flex",justifyContent:"center"}}>
  <p style={{fontSize:"14px",fontWeight:"400",marginTop:"5%",width:"80%"}}>Please enter your phone number to link it and continue to payment.</p>
  
  </div>
  
  <div style={{display:"flex",justifyContent:"center"}}>
  <div style={{border:"2px solid #8080805e",borderRadius:"10px",marginTop:"7%",    width: "80%"}}>
  <input   ref={inputRef}  type="number" min="0" inputmode="numeric" pattern="[0-9]*" title="Non-negative integral number"  style={{padding:"2%",paddingLeft:"0%", fontSize:"16px",marginLeft:"-8vw",}} value={props&&props.number} 
   onChange={(e)=>{handleNumber(e)}} 
  placeholder="Your Mobile Number" />
  </div>
  </div>
  <div style={{display:"flex",paddingLeft:"10%"}}>
  {props&&props.numberError&&<p style={{color:"rgba(234, 67, 53, 1)",textAlign:"start",marginTop:"3%",fontSize:"12px"}}>{props&&props.numberErrorMsg}</p>}
  </div>
  
  <div style={{display:"flex",justifyContent:"center"}}>
  <div style={{display:"flex",    justifyContent:"space-between",   marginTop:props&&props.numberError?"7%":"15%",  width: "80%"}}>
    <button style={{    padding:" 0%",
    width: "48%",
    border: "2px solid rgba(0, 177, 119, 1)",
    textAlign: "center",
    borderRadius: "10px",color:"rgba(0, 177, 119, 1)"}}  onClick={(e)=>props&&props.closePop(e)} >
    Cancel
    </button>
  
    <button   onClick={props&&props.googleAddnumber} style={{    padding:" 5%",
    width: "48%",
   
    textAlign: "center",
    borderRadius: "10px",background:" rgba(0, 177, 119, 1)",fontSize:"15px",fontWeight:"700",color:"white"}}>
    Continue
    </button>
  </div>
  </div>
  
  </div>
  
  
  
              </div>
        
           
            </div>
            </div>
            </div>}
    
    
    </>)
  }

  
  
  const GoogleNumberOtp=()=>{
    const [time, setTime] = useState(30); // Timer value
    const [inputValue, setInputValue] = useState(""); // User input
    const inputRef = useRef(null); // Reference to the input field
  
    // Timer logic
    useEffect(() => {
      const timer = setInterval(() => {
        setTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0)); // Countdown
      }, 1000);
  
      return () => clearInterval(timer); // Cleanup on unmount
    }, []);
  
    // Focus on the input field when the component mounts
    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, []);
  
    // Handle input changes
    const handleInputChange = (e) => {
      setInputValue(e.target.value);
    };
  
    // Handle resend button click
    const handleResend = () => {
      props&&props.googleAddnumber()// Hide the "Resend" button
      setTime(30); // Reset timer
      setInputValue(""); // Clear input
      if (inputRef.current) {
        inputRef.current.focus(); // Focus back on input
      }
    };
  
    return(
    <>
  
    <div className="modal">
  
  <div style={{display:"flex",justifyContent:"center"}}>
    
    <div style={{padding:"5%",marginTop:"20%",    width: "90%"}}>
  
          <div style={{background:"white",widows:"100%" ,height:"90%",borderRadius:"10px"}}>
  
          <div style={{display:"flex",justifyContent:"center",position: "relative",
  top:"-35px"}}>
  
  <svg  style={{width:"90px"}}  xmlns="http://www.w3.org/2000/svg" width="142" height="66" viewBox="0 0 142 66" fill="none">
  <g clip-path="url(#clip0_61_2282)">
  <rect width="142" height="66" rx="33" fill="white"/>
  <path d="M112.017 21.564C109.527 21.564 107.503 23.6012 107.503 26.1084V30.5345H116.54V26.1084C116.54 23.6012 114.506 21.564 112.017 21.564Z" fill="#029646"/>
  <path d="M124.558 0H17.4418C7.85532 0 0 7.88827 0 17.5076V48.3694C0 58.0039 7.85532 65.877 17.4418 65.877H124.558C134.145 65.877 142 58.0039 142 48.3694V17.5076C142 7.88827 134.145 0 124.558 0ZM37.9472 37.7194L42.1317 42.291L34.8837 47.748L31.9107 42.291C31.4726 41.5119 30.7868 39.984 29.823 37.7194C28.7686 40.2083 28.0677 41.7241 27.7202 42.291L24.705 47.748L17.2545 42.291L21.7592 37.7194C23.0282 36.4613 24.2578 35.382 25.4724 34.4968C24.2337 34.3846 22.6052 34.1542 20.596 33.7752L14.3571 32.7566L17.2515 24.2317L22.8469 26.7843C23.436 27.0511 24.9014 27.8909 27.2338 29.2824C26.7353 27.0178 26.415 25.3352 26.27 24.2317L25.4754 18.1291H34.361L33.6419 24.2317C33.4848 25.7172 33.1404 27.3998 32.6298 29.2824C33.654 28.767 34.3308 28.4244 34.651 28.2365C35.7749 27.6089 36.642 27.1754 37.2251 26.8965L42.8236 24.2317L45.5971 32.7566L39.4065 34.0541C38.2735 34.2724 36.5937 34.4149 34.361 34.4968C35.8746 35.6852 37.059 36.7523 37.9472 37.7194ZM78.9671 37.7194L83.1576 42.291L75.9096 47.7449L72.9397 42.291C72.5016 41.5119 71.8158 39.984 70.855 37.7194C69.7975 40.2083 69.1026 41.7241 68.7552 42.291L65.7339 47.7449L58.2865 42.291L62.7912 37.7194C64.0601 36.4613 65.2868 35.382 66.5043 34.4968C65.2717 34.3846 63.6371 34.1542 61.628 33.7752L55.386 32.7566L58.2835 24.2317L63.8819 26.7843C64.465 27.0511 65.9363 27.8909 68.2657 29.2824C67.7551 27.0178 67.4349 25.3352 67.2989 24.2317L66.5013 18.1351H75.3899L74.6678 24.2317C74.5047 25.7172 74.1663 27.3998 73.6617 29.2824C74.6799 28.767 75.3567 28.4244 75.68 28.2365C76.7978 27.6089 77.668 27.1754 78.2541 26.8965L83.8555 24.2317L86.6321 32.7566L80.4354 34.0541C79.3025 34.2724 77.6287 34.4149 75.3929 34.4968C76.8945 35.6852 78.0819 36.7523 78.9671 37.7194ZM124.93 45.4439C124.93 47.3205 123.398 48.8545 121.531 48.8545H102.512C100.642 48.8545 99.113 47.3205 99.113 45.4439V33.942C99.113 32.0654 100.642 30.5314 102.512 30.5314H102.971V26.1053C102.971 21.094 107.029 17.0165 112.017 17.0165C117.008 17.0165 121.069 21.091 121.069 26.1053V30.5314H121.528C123.392 30.5314 124.927 32.0654 124.927 33.942L124.93 45.4439Z" fill="#029646"/>
  </g>
  <defs>
  <clipPath id="clip0_61_2282">
  <rect width="142" height="66" rx="33" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  </div>
  
  <div style={{position:"relative",top:"-51px",textAlign:"center",padding:"10%"}}>
  
  
  
  <h1 style={{fontSize:"16px",fontWeight:"700"}}>Enter OTP</h1>
  <p style={{fontSize:"14px",fontWeight:"400",marginTop:"5%"}}>Enter the 4-digit code sent to your number {props&&props.number}.</p>
  
  
  <div style={{border:"2px solid #8080805e",borderRadius:"10px",marginTop:"7%"}}>
  <input   ref={inputRef} value={props&&props.otp}  style={{padding:"2%",paddingLeft:"0%", fontSize:"16px",marginLeft:"0px",}} type="number" min="0" inputmode="numeric" pattern="[0-9]*" title="Non-negative integral number"  
  onChange={(e)=>{handleOtp(e)}} 
  placeholder="Please enter the OTP" />
  </div>
  <div /* tyle={{display:"flex",justifyContent:"start", alignItems:"center",    justifyContent:"space-between"}} */>
  
  <div>
  {props&&props.otpError&&<p style={{color:"rgba(234, 67, 53, 1)",textAlign:"start",marginTop:"3%",fontSize:"12px"}}  >{props&&props.otpErrorMsg}</p>}
  </div>
  <div>
          {time > 0 ? (
           <p  style={{ padding: "", fontSize: "12px",color:"gray" ,textAlign:"center",marginTop:"3%"}}>Didn’t receive code? Resend in {time}s</p>
          ) : (
            <div style={{display:"flex",    "justify-content":"flex-end",
              marginTop: "2vw"}}>
            <button onClick={handleResend} style={{ padding: "", fontSize: "12px",color:"green" }}>
            Resend OTP
          </button>
          </div>
          )}
        </div>
  {/* <div><OtpTimer/></div> */}
  
  </div>
  
  <div style={{ fontSize: "16px" }}>
  
        </div>
  
  <div style={{display:"flex",    justifyContent:"space-between",    marginTop:"15%"}}>
  <button style={{    padding:" 0%",
  width: "48%",
  border: "2px solid rgba(0, 177, 119, 1)",
  textAlign: "center",
  borderRadius: "10px",color:"rgba(0, 177, 119, 1)"}} onClick={(e)=>props&&props.closeOTpPop(e)} >
  Cancel
  </button>
  <button  onClick={props&&props.googleOtpSubmit}  style={{    padding:" 5%",
  width: "48%",
  
  textAlign: "center",
  borderRadius: "10px",background:" rgba(0, 177, 119, 1)",fontSize:"15px",fontWeight:"700",color:"white"}}>
  SUBMIT
  </button>
  </div>
  


  </div>
  
  
  
          </div>
    
       
        </div>
        </div>
        </div>
        </>)
  } 
  
  

  
  
  const GoogleSuccess=()=>{
    return(
    <>
    <div className="modal">
  
    <div style={{display:"flex",justifyContent:"center"}}>
    <div style={{padding:"5%",marginTop:"20%",    width:"90%"}}>
  
          <div style={{background:"white",widows:"100%" ,height:"267px",borderRadius:"10px"}}>
  
          <div style={{display:"flex",justifyContent:"center",position: "relative",
  top:"-48px"}}>
  
  <svg style={{    width:"87px"}} xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" fill="none">
  <path d="M95 48C95 51.94 88.56 54.98 87.58 58.6C86.58 62.36 90.62 68.2 88.7 71.5C86.76 74.84 79.66 74.26 76.96 76.96C74.26 79.66 74.84 86.78 71.5 88.7C68.2 90.6 62.36 86.56 58.6 87.58C54.96 88.56 51.94 95 48 95C44.06 95 41.02 88.56 37.4 87.58C33.64 86.58 27.8 90.62 24.5 88.7C21.16 86.76 21.74 79.66 19.04 76.96C16.34 74.26 9.22 74.84 7.3 71.5C5.4 68.2 9.44 62.36 8.42 58.6C7.44 54.98 1 51.94 1 48C1 44.06 7.44 41.02 8.42 37.4C9.42 33.64 5.38 27.8 7.3 24.5C9.24 21.16 16.34 21.74 19.04 19.04C21.74 16.34 21.16 9.22 24.5 7.3C27.8 5.4 33.64 9.44 37.4 8.42C41.02 7.44 44.06 1 48 1C51.94 1 54.98 7.44 58.6 8.42C62.36 9.42 68.2 5.38 71.5 7.3C74.84 9.24 74.26 16.34 76.96 19.04C79.66 21.74 86.78 21.16 88.7 24.5C90.6 27.8 86.56 33.64 87.58 37.4C88.56 41.02 95 44.06 95 48Z" fill="#049E79"/>
  <path d="M48.0001 78.9201C65.0767 78.9201 78.9201 65.0767 78.9201 48.0001C78.9201 30.9234 65.0767 17.0801 48.0001 17.0801C30.9234 17.0801 17.0801 30.9234 17.0801 48.0001C17.0801 65.0767 30.9234 78.9201 48.0001 78.9201Z" fill="#068463"/>
  <path d="M65.6602 36.46C64.1002 34.9 61.5602 34.9 60.0002 36.46L43.2402 53.22L35.3202 45.3C33.7602 43.74 31.2202 43.74 29.6602 45.3C28.1002 46.86 28.1002 49.4 29.6602 50.96L40.4202 61.72C41.1802 62.48 42.2002 62.9 43.2602 62.9C44.3202 62.9 45.3402 62.48 46.1002 61.72L65.6802 42.12C67.2202 40.56 67.2202 38.02 65.6602 36.46Z" fill="white"/>
  </svg>
  </div>
  
  <div style={{position:"relative",top:"-51px",textAlign:"center",padding:"5%"}}>
  
  
  
  <h1 style={{fontSize:"16px",fontWeight:"700"}}>Successful</h1>
  <p style={{fontSize:"14px",fontWeight:"400",marginTop:"5%"}}>Your Mobile is Linked. Proceed to payment and enjoy your order.{props&&props.number}.</p>
  
  
  
  
  <div style={{display:"flex",    justifyContent:"space-between",    marginTop:"15%"}}>
  
  <button  onClick={handleReload}  style={{    padding:" 5%",
  width: "100%",
  
  textAlign: "center",
  borderRadius: "10px",background:" rgba(0, 177, 119, 1)",fontSize:"15px",fontWeight:"700",color:"white"}}>
  Done
  </button>
  </div>
  
  </div>
  
  
  
          </div>
    
       
        </div>
        </div>
        
        </div>
        </>)
  }
  
  useEffect(()=>{
  
    console.log("google_OTP_Pop_flag",props&&props.google_OTP_Pop_flag)
  
  },[props&&props.google_OTP_Pop_flag])
  
  
  
  


  return (
    <>
    {console.log("khan props&&props.google_Pop_flag",props&&props.google_Pop_flag)}
{props&&props.google_success_flag&&<GoogleSuccess/>}
   {props&&props.google_OTP_Pop_flag&&<GoogleNumberOtp/>}
   {(props&&props.google_Pop_flag)&&localStorage.getItem("isGuest")=="true"&&<AddGoogleNumber/>}
      <Box
        style={{
          height: props.GuestLogin ?"100vh":"",
          boxShadow: "none",
          background:
            "radial-gradient(circle, rgba(245, 233, 233, 0.408) 0%, rgba(185, 245, 247, 0.34) 100%)",
        }}


      >

        {" "}
        {props.GuestLogin ? (
          <>
            {
              cartFlag == "true" && (
                <>
                  {props.loader && <WaitingLoder />}

                  <MyCartHeader title={"My Cart"} route={`/items?machineId=${props && props.precardVm}`} />

                  <Box className="_2yoTv ns7Wo" style={{ boxShadow: "none" }}>
                    <div>


                      <div>
                        <div className="_2NVhy _3hjyL">
                          <div>
                            <div style={{ padding: 0 }}>
                              <div>
                                <div />
                              </div>
                            </div>
                            <div style={{ padding: 0 }}>
                              <div>
                                <div />
                                <div
                                  data-testid="grid-header"
                                  className="styles_headerContainer__2UgeD"
                                />
                              </div>
                            </div>
                            <div style={{ padding: "8px 0px 0px" }}>
                              <div>
                                <div />
                              </div>
                            </div>
                            <div>
                              <div>
                                <div />
                              </div>
                            </div>

                            <div

                              style={{ padding: 0, "overflow-y": "scroll" }}
                            >
                              <div>
                                <div />
                                <div
                                  data-testid="grid-header"
                                  className="styles_headerContainer__2UgeD"
                                >
                                  <div>
                                    <span
                                      className="styles_headerContainerSubtitle__1WRg5"
                                      aria-hidden="true"
                                    >
                                      <h3
                                        style={{

                                          marginLeft: "5%",
                                          fontSize: "17px",
                                          color: "#718198",

                                          /* M17 */
                                          "font-family": "Roboto",

                                          "font-style": "normal",
                                          "font-weight": "500",
                                        }}
                                      >
                                        Items In Your Cart {" "}
                                      </h3>
                                    </span>
                                  </div>
                                </div>
                                {props && props.comboCart && <ComboComponent />}

                                <Box

                                  style={{ boxShadow: "none" }}
                                  margin={"3%"}


                                >
                                  {list &&
                                    list.map((el, index) => (

                                      <Box

                                        marginBottom={"5%"}
                                        boxShadow={"0px 4px 10px 0px rgba(56, 79, 111, 0.12)"}

                                        borderRadius={"16px"}
                                        width={"100%"}

                                        style={{ background: "white" }}

                                      >

                                        {console.log("el---->", el)}
                                        <Box height={"108px"}>
                                          <Box
                                            padding={"4%"}
                                          >
                                            <Box>
                                              <Box
                                                className="styles_ImageContainer__2rk9a"

                                                style={{
                                                  background: "rgb(255, 255, 255)",
                                                  height: "78px",
                                                  width: "77px"
                                                }}
                                              >
                                                <img
                                                  className="styles_Image__1fplJ"
                                                  loading="lazy"

                                                  src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${el.variantImages[0]}`}
                                                />
                                              </Box>

                                            </Box>
                                            <Box

                                              className="styles_containerRestaurant__3vhx3"
                                              style={{ padding: "12px!important" }}
                                            >
                                              <div
                                                className="styles_containerImageBadge__14fk3"
                                                style={{ fontFamily: "Roboto" }}
                                              >
                                                <div
                                                  data-testid="resturant-card-name"
                                                  className="styles_restaurantName__29jAP"
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  <TruncatedVmname
                                                    text={el.mvName}
                                                    limit={25}
                                                  />
                                                </div>

                                              </div>

                                              <div


                                              >
                                                <span
                                                  data-testid="restaurant-card-cuisines"
                                                  style={{
                                                    fontSize: "12px",
                                                    color: "rgba(148, 163, 184, 1)",
                                                    fontFamily: "Roboto",



                                                    "font-style": "normal",
                                                    "font-weight": "400",
                                                    "line-height": "20px",
                                                  }}
                                                >
                                                  <span>Tray:{" "}{el.slotId &&
                                                    el.slotId.toString()[0]}</span>

                                                </span>
                                              </div>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                  alignItems: "flex-end"
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex", "align-items": "center", width: "65%"
                                                  }}
                                                >
                                                  {el.discountedAmount ? (
                                                    <h2
                                                      style={{
                                                        textDecoration:
                                                          "line-through",
                                                        color: "#8d97a1",
                                                        fontSize: "14px",
                                                      }}
                                                    >
                                                      Rs.{""}{" "}
                                                      {el.amount
                                                        .toFixed(2)}
                                                    </h2>
                                                  ) : (
                                                    <h2
                                                      style={{
                                                        color: "#718198",
                                                        "text-align": "right",
                                                        /* SM14 */
                                                        "font-family": "Roboto",
                                                        "font-size": "14px",
                                                        "font-style": "normal",
                                                        "font-weight": "600",
                                                        "line-height": "150% ",/* 21px */
                                                        "letter-spacing": "0.2px"
                                                      }}
                                                    >
                                                      Rs.{""}{" "}
                                                      {(el.amount
                                                      ).toFixed(2)}
                                                    </h2>
                                                  )}

                                                  {el.discountedAmount && (
                                                    <h2
                                                      style={{
                                                        color: "#718198",
                                                        "text-align": "right",
                                                        /* SM14 */
                                                        "font-family": "Roboto",
                                                        "font-size": "14px",
                                                        "font-style": "normal",
                                                        "font-weight": "600",
                                                        "line-height": "150% ",/* 21px */
                                                        "letter-spacing": "0.2px"
                                                      }}
                                                    >
                                                      {" "}
                                                      Rs.{""}{" "}
                                                      {
                                                        el.discountedAmount.toFixed(2)
                                                      }
                                                    </h2>
                                                  )}
                                                </div>

                                                {el.count > 0 ? (
                                                  <div
                                                    style={{
                                                      border:
                                                        "2px solid rgb(0, 177, 119)",
                                                      display: "flex",
                                                      width: "100px",
                                                      height: "31px",
                                                      backgroundColor:
                                                        "rgb(0, 177, 119)",
                                                      color: "white",
                                                      justifyContent:
                                                        "space-around",
                                                      alignItems:
                                                        "center",
                                                      padding: "10px",
                                                      borderRadius:
                                                        "15px",

                                                      "border-radius":
                                                        "8px",
                                                      border:
                                                        "1px solid #00B177",
                                                      background:
                                                        "rgba(0, 177, 119, 0.04)",
                                                    }}
                                                  >
                                                    <h3
                                                      onClick={(e) => {
                                                        props.decreaseQuantity(
                                                          e,
                                                          index,
                                                          el.slotId
                                                        );
                                                      }}
                                                      style={{
                                                        color: "#00B177",
                                                      }}
                                                    >
                                                      -
                                                    </h3>
                                                    <h3
                                                      style={{
                                                        color: "#583C43",
                                                        "font-family":
                                                          "Roboto",
                                                        "font-size":
                                                          "14px",
                                                        "font-style":
                                                          "normal",
                                                        "font-weight":
                                                          "400",
                                                      }}
                                                    >
                                                      {el.count}{" "}
                                                      {el.slot_id}
                                                    </h3>
                                                    <h3
                                                      onClick={(e) => {
                                                        props.increaseQuantity(
                                                          e,
                                                          index,
                                                          el.slotId
                                                        );
                                                      }}
                                                      style={{
                                                        color: "#00B177",
                                                      }}
                                                    >
                                                      +
                                                    </h3>
                                                  </div>
                                                ) : (
                                                  <>
                                                    <div
                                                      style={{
                                                        border:
                                                          "2px solid rgb(0, 177, 119)",
                                                        display: "flex",
                                                        width: "100px",
                                                        "background-color":
                                                          "rgba(0, 177, 119, 0.04)",
                                                        color: "#00B177",
                                                        justifyContent:
                                                          "space-around",
                                                        alignItems:
                                                          "center",
                                                        padding: "10px",
                                                        borderRadius:
                                                          "15px",
                                                      }}
                                                      onClick={(e) => {
                                                        props.increaseQuantity(
                                                          e,
                                                          index,
                                                          el.slotId
                                                        );
                                                      }}
                                                    >
                                                      ADD
                                                    </div>
                                                  </>
                                                )}
                                              </div>
                                            </Box>
                                          </Box>
                                        </Box>

                                        <div />

                                      </Box>

                                    ))}
                                  {( props.comboCart == null) && <>{!(localStorage.getItem("Guest_clientId")) && <>
                                    {!(props && props.couponReward) ? (
                                      <Link to='/coupon'>
                                        <div
                                          className="styles_row__1ivP1 shadow-box"
                                          data-testid="grid-row"
                                          style={{
                                            marginBottom: "-5px",
                                            background: "linear-gradient(0deg, rgba(250, 225, 75, 0.16) 0%, rgba(250, 225, 75, 0.16) 100%), rgb(255, 255, 255)",

                                            "border-radius": "10px",

                                            height: "63px",
                                            marginBottom: 5,
                                            //background:"linear-gradient(0deg, rgba(250, 225, 75, 0.16) 0%, rgba(250, 225, 75, 0.16) 100%), #FFF",
                                          }}
                                        >
                                          <div
                                            className="styles_slide__2c207"
                                            style={{ marginRight: 0 }}
                                          >
                                            <div>
                                              <div
                                                className="styles_cardWithPadding__JE1QE "
                                                data-testid="home-restaurant-card-wrapper"
                                                style={{
                                                  width:
                                                    "calc((100vw - 0px) - 12px)",
                                                }}
                                              >
                                                <div className="styles_container__fLC0R" style={{ padding: "5%" }}>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      "align-items": "center",
                                                    }}
                                                  >
                                                    <img
                                                      style={{
                                                        width: "20px",
                                                        height: "20px",
                                                      }}
                                                      src={coupon2}
                                                    />
                                                    <h2
                                                      style={{

                                                        "font-size": "15px",
                                                        color: " #384F6F",
                                                        "font-family": "Roboto",
                                                        "font-size": "15px",
                                                        marginLeft: "7px",
                                                      }}
                                                    >
                                                      Apply Coupon:
                                                      <span
                                                        style={{
                                                          color: "#00B177",

                                                          "font-family":
                                                            "Roboto",
                                                          "font-size": "15px",
                                                          "font-style":
                                                            "normal",
                                                          "font-weight": "600",
                                                          "line-height":
                                                            "normal",
                                                        }}
                                                      >
                                                        {" "}

                                                      </span>{" "}
                                                    </h2>
                                                  </div>
                                                  {/*       <p
                                                    style={{
                                                      fontSize: "13px",
                                                      "margin-top": "1px",
                                                      color: "#64748B",
                                                    
                                                      "font-family": "Roboto",
                                                      "font-size": "13px",
                                                      "font-style": "normal",
                                                      "font-weight": "400",
                                                      "line-height":
                                                        "150%" ,
                                                      "letter-spacing": "0.2px",
                                                      "margin-left": "26px",
                                                    }}
                                                  >
                                                    You saved{" "}
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                        color: "#384F6F",
                                                        "font-family": "Roboto",
                                                        "font-size": "13px",
                                                        "font-style": "normal",
                                                        "font-weight": "700",
                                                        "line-height": "150%",
                                                        "letter-spacing":
                                                          "0.2px",
                                                      }}
                                                    >
                                                      ₹{""}{props&&props.couponReward&&props.couponReward.count}
                                                      {props &&
                                                        props.couponAppled &&
                                                        props.couponAppled
                                                          .reward &&
                                                        props.couponAppled
                                                          .reward.count.toFixed(2)}
                                                    </span>{" "}
                                                    on your final bill
                                                  </p> */}
                                                </div>
                                              </div>
                                              <div />
                                            </div>
                                          </div>
                                        </div>
                                      </Link>
                                    ) :

                                      <div
                                        className="styles_row__1ivP1 shadow-box"
                                        data-testid="grid-row"
                                        style={{
                                          marginBottom: "-5px",
                                          background: "linear-gradient(0deg, rgba(250, 225, 75, 0.16) 0%, rgba(250, 225, 75, 0.16) 100%), rgb(255, 255, 255)",
                                          marginTop: "4%",
                                          "border-radius": "10px",

                                          height: "63px",
                                          marginBottom: 5,
                                          //background:"linear-gradient(0deg, rgba(250, 225, 75, 0.16) 0%, rgba(250, 225, 75, 0.16) 100%), #FFF",
                                        }}
                                      >
                                        <div
                                          className="styles_slide__2c207"
                                          style={{ marginRight: 0 }}
                                        >
                                          <div>
                                            <div
                                              className="styles_cardWithPadding__JE1QE "
                                              data-testid="home-restaurant-card-wrapper"
                                              style={{
                                                width:
                                                  "calc((100vw - 0px) - 12px)",
                                              }}
                                            >
                                              <div className="styles_container__fLC0R">
                                                <div style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "space-between"
                                                }}>
                                                  <div> <div
                                                    style={{
                                                      display: "flex",
                                                      "align-items": "flex-end",
                                                    }}
                                                  >
                                                    <img
                                                      style={{
                                                        width: "20px",
                                                        height: "20px",
                                                      }}
                                                      src={coupon2}
                                                    />
                                                    <h2
                                                      style={{
                                                        marginTop: "15px",
                                                        "font-size": "15px",
                                                        color: " #384F6F",
                                                        "font-family": "Roboto",
                                                        "font-size": "15px",
                                                        marginLeft: "7px",
                                                      }}
                                                    >
                                                      Applied Coupon:
                                                      <span
                                                        style={{
                                                          color: "#00B177",

                                                          "font-family":
                                                            "Roboto",
                                                          "font-size": "15px",
                                                          "font-style":
                                                            "normal",
                                                          "font-weight": "600",
                                                          "line-height":
                                                            "normal",
                                                          textTransform: "uppercase"
                                                        }}
                                                      >
                                                        {" "}  {localStorage.getItem("appliedCouponName")}

                                                      </span>{" "}
                                                    </h2>
                                                  </div></div>

                                                  <h1 style={{ marginTop: "11px", marginRight: "26px", fontSize: "14px" }} onClick={(e) => { props.RemoveCoupon() }}>Remove</h1>
                                                </div>
                                                <p
                                                  style={{
                                                    fontSize: "13px",
                                                    "margin-top": "1px",
                                                    color: "#64748B",
                                                    /* R13 */
                                                    "font-family": "Roboto",
                                                    "font-size": "13px",
                                                    "font-style": "normal",
                                                    "font-weight": "400",
                                                    "line-height":
                                                      "150%" /* 19.5px */,
                                                    "letter-spacing": "0.2px",
                                                    "margin-left": "26px",
                                                  }}
                                                >
                                                  You saved{" "}
                                                  {!(localStorage.getItem("Guest_clientId")) && <span
                                                    style={{
                                                      fontWeight: "bold",
                                                      color: "#384F6F",
                                                      "font-family": "Roboto",
                                                      "font-size": "13px",
                                                      "font-style": "normal",
                                                      "font-weight": "700",
                                                      "line-height": "150%",
                                                      "letter-spacing":
                                                        "0.2px",
                                                    }}
                                                  >
                                                    ₹{""}{props.couponReward.type == "freegift" ? props && props.couponReward && props.couponReward.amount : props && props.couponReward && props.couponReward.count}
                                                    {/*   {props &&
                                                    props.couponAppled &&
                                                    props.couponAppled
                                                      .reward &&
                                                    props.couponAppled
                                                      .reward.count.toFixed(2)} */}
                                                  </span>}{" "}
                                                  {props.couponReward.type == "freegift" ? <>rupees on this order</> : <>{props.couponReward.type == "cashback" ? <>rupees on this order</> : <>on your final bill</>}</>}
                                                </p>
                                              </div>
                                            </div>
                                            <div />
                                          </div>
                                        </div>
                                      </div>}

                                  </>
                                  }</>}
                                  {props && props.couponReward && props.couponReward.type == "freegift" && <div
                                    className="styles_row__1ivP1 shadow-box"
                                    data-testid="grid-row"
                                    style={{
                                      marginBottom: "-5px",
                                      marginTop: "4%",
                                      "border-radius": "10px",

                                      "background": "white",
                                      height: props && props.couponReward && props.couponReward.type == "freegift" ? "123px" : "37px",
                                      marginBottom: "50%",
                                    }}
                                  >
                                    <div
                                      className="styles_slide__2c207"
                                      style={{ marginRight: 0 }}
                                    >
                                      <div>
                                        <div
                                          className="styles_cardWithPadding__JE1QE"
                                          data-testid="home-restaurant-card-wrapper"
                                          style={{
                                            width:
                                              "calc((100vw - 0px) - 12px)",
                                          }}
                                        >
                                          <a
                                            data-testid="resturant-card-anchor-container"
                                            className="styles_container__fLC0R"
                                            aria-label="Restaurant name: Bakingo, 
Cuisines: Bakery, Desserts, Beverages, Snacks,
Area: Rohini,
3.0 km away,
Rating: 4.4,
Delivers in: 25 mins,
Cost is: RUPEES 300 for two,


Double tap to open restaurant menu."
                                            tabIndex={0}
                                            role="button"
                                          >

                                            <div
                                              style={{
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                "align-items": "center",
                                                "margin-right": "28px",
                                                marginTop: "10px",
                                              }}
                                            >
                                              <h2
                                                style={{
                                                  "font-family": "Roboto",
                                                  "font-size": "14px",
                                                  "font-style": "normal",
                                                  "font-weight": "600",
                                                  "line-height":
                                                    "150%" /* 21px */,
                                                  "letter-spacing": "0.2px",
                                                  color: "#384F6F"

                                                }}
                                              >
                                                Grand Total
                                              </h2>
                                              <h2
                                                style={{
                                                  "font-family": "Roboto",
                                                  "font-size": "14px",
                                                  "font-style": "normal",
                                                  "font-weight": "600",
                                                  "line-height":
                                                    "150%" /* 21px */,
                                                  "letter-spacing": "0.2px",
                                                  color: "#384F6F"
                                                }}
                                              >
                                                ₹{" "}
                                                {finalAmountGrand && finalAmountGrand.toFixed(2)}
                                              </h2>


                                            </div>
                                          </a>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            "justify-content":
                                              "space-between",
                                            "align-items": "center",
                                            "margin-right": "44px",
                                            marginTop: "5px",
                                            paddingLeft: "16px"
                                          }}
                                        >
                                          <h2
                                            style={{
                                              "font-family": "Roboto",
                                              "font-size": "14px",
                                              "font-style": "normal",
                                              "font-weight": "600",
                                              "line-height":
                                                "150%" /* 21px */,
                                              "letter-spacing": "0.2px",
                                              color: "#384F6F"

                                            }}
                                          >
                                            Free Gift added
                                          </h2>



                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            "justify-content":
                                              "space-between",
                                            "align-items": "center",
                                            "margin-right": "44px",
                                            marginTop: "10px",
                                            paddingLeft: "16px"
                                          }}
                                        >
                                          <h2
                                            style={{
                                              "font-family": "Roboto",
                                              "font-size": "12px",
                                              "font-style": "normal",

                                              "line-height":
                                                "150%" /* 21px */,
                                              "letter-spacing": "0.2px",
                                              color: "rgb(100, 116, 139)"

                                            }}
                                          >
                                            {props.couponReward && props.couponReward.mvName}
                                          </h2>
                                          <h2 style={{ color: "rgb(100, 116, 139)", "fontSize": "12px" }}>

                                            ₹{" "}{props.couponReward && props.couponReward.amount.toFixed(2)}
                                          </h2>


                                        </div>
                                      </div>
                                    </div>
                                  </div>}
                                  {props && props.couponReward && props.couponReward.type == "cashback" && <div
                                    className="styles_row__1ivP1 shadow-box"
                                    data-testid="grid-row"
                                    style={{
                                      marginBottom: "-5px",
                                      marginTop: "4%",
                                      "border-radius": "10px",

                                      "background": "white",
                                      height: props && props.couponReward && props.couponReward.type == "cashback" ? "123px" : "37px",
                                      marginBottom: "50%",
                                    }}
                                  >
                                    <div
                                      className="styles_slide__2c207"
                                      style={{ marginRight: 0 }}
                                    >
                                      <div>
                                        <div
                                          className="styles_cardWithPadding__JE1QE"
                                          data-testid="home-restaurant-card-wrapper"
                                          style={{
                                            width:
                                              "calc((100vw - 0px) - 12px)",
                                          }}
                                        >
                                          <a
                                            data-testid="resturant-card-anchor-container"
                                            className="styles_container__fLC0R"
                                            aria-label="Restaurant name: Bakingo, 
Cuisines: Bakery, Desserts, Beverages, Snacks,
Area: Rohini,
3.0 km away,
Rating: 4.4,
Delivers in: 25 mins,
Cost is: RUPEES 300 for two,


Double tap to open restaurant menu."
                                            tabIndex={0}
                                            role="button"
                                          >

                                            <div
                                              style={{
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                "align-items": "center",
                                                "margin-right": "28px",
                                                marginTop: "10px",
                                              }}
                                            >
                                              <h2
                                                style={{
                                                  "font-family": "Roboto",
                                                  "font-size": "14px",
                                                  "font-style": "normal",
                                                  "font-weight": "600",
                                                  "line-height":
                                                    "150%" /* 21px */,
                                                  "letter-spacing": "0.2px",
                                                  color: "#384F6F"

                                                }}
                                              >
                                                Grand Total
                                              </h2>
                                              <h2
                                                style={{
                                                  "font-family": "Roboto",
                                                  "font-size": "14px",
                                                  "font-style": "normal",
                                                  "font-weight": "600",
                                                  "line-height":
                                                    "150%" /* 21px */,
                                                  "letter-spacing": "0.2px",
                                                  color: "#384F6F"
                                                }}
                                              >
                                                ₹{" "}
                                                {finalAmountGrand && finalAmountGrand.toFixed(2)}
                                              </h2>


                                            </div>
                                          </a>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            "justify-content":
                                              "space-between",
                                            "align-items": "center",
                                            "margin-right": "44px",
                                            marginTop: "5px",
                                            paddingLeft: "16px"
                                          }}
                                        >
                                          <h2
                                            style={{
                                              "font-family": "Roboto",
                                              "font-size": "14px",
                                              "font-style": "normal",
                                              "font-weight": "600",
                                              "line-height":
                                                "150%" /* 21px */,
                                              "letter-spacing": "0.2px",
                                              color: "#384F6F"

                                            }}
                                          >
                                            Cashback Earned
                                          </h2>



                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            "justify-content":
                                              "space-between",
                                            "align-items": "center",
                                            "margin-right": "44px",
                                            marginTop: "10px",
                                            paddingLeft: "16px"
                                          }}
                                        >
                                          <h2
                                            style={{
                                              "font-family": "Roboto",
                                              "font-size": "12px",
                                              "font-style": "normal",

                                              "line-height":
                                                "150%" /* 21px */,
                                              "letter-spacing": "0.2px",
                                              color: "rgb(100, 116, 139)"

                                            }}
                                          >
                                            Cashback will be added to your Daalchini <br /> Points Wallet after Pickup
                                          </h2>
                                          <h2 style={{ color: "#ffb300", "fontSize": "12px" }}>

                                            +{" "}{props.couponReward.count.toFixed(2)}
                                          </h2>


                                        </div>
                                      </div>
                                    </div>
                                  </div>}

                                  {(props && props.couponReward && props.couponReward.type == "discount") && <div
                                    className="styles_row__1ivP1 shadow-box"
                                    data-testid="grid-row"
                                    style={{
                                      marginBottom: "-5px",
                                      marginTop: "4%",
                                      "border-radius": "10px",

                                      "background": "white",
                                      height: "37px",
                                      marginBottom: "50%",
                                    }}
                                  >
                                    <div
                                      className="styles_slide__2c207"
                                      style={{ marginRight: 0 }}
                                    >
                                      <div>
                                        <div
                                          className="styles_cardWithPadding__JE1QE"
                                          data-testid="home-restaurant-card-wrapper"
                                          style={{
                                            width:
                                              "calc((100vw - 0px) - 12px)",
                                          }}
                                        >
                                          <a
                                            data-testid="resturant-card-anchor-container"
                                            className="styles_container__fLC0R"
                                            aria-label="Restaurant name: Bakingo, 
Cuisines: Bakery, Desserts, Beverages, Snacks,
Area: Rohini,
3.0 km away,
Rating: 4.4,
Delivers in: 25 mins,
Cost is: RUPEES 300 for two,


Double tap to open restaurant menu."
                                            tabIndex={0}
                                            role="button"
                                          >

                                            <div
                                              style={{
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                "align-items": "center",
                                                "margin-right": "28px",
                                                marginTop: "10px",
                                              }}
                                            >
                                              <h2
                                                style={{
                                                  "font-family": "Roboto",
                                                  "font-size": "14px",
                                                  "font-style": "normal",
                                                  "font-weight": "600",
                                                  "line-height":
                                                    "150%" /* 21px */,
                                                  "letter-spacing": "0.2px",
                                                  color: "#384F6F"

                                                }}
                                              >
                                                Grand Total
                                              </h2>
                                              <h2
                                                style={{
                                                  "font-family": "Roboto",
                                                  "font-size": "14px",
                                                  "font-style": "normal",
                                                  "font-weight": "600",
                                                  "line-height":
                                                    "150%" /* 21px */,
                                                  "letter-spacing": "0.2px",
                                                  color: "#384F6F"
                                                }}
                                              >
                                                ₹{" "}
                                                {finalAmountGrandDiscount && (finalAmountGrandDiscount).toFixed(2)}
                                              </h2>


                                            </div>
                                          </a>
                                        </div>


                                      </div>
                                    </div>
                                  </div>}
                                  {!(props && props.couponReward) && <div
                                    className="styles_row__1ivP1 shadow-box"
                                    data-testid="grid-row"
                                    style={{
                                      marginBottom: "-5px",
                                      marginTop: "4%",
                                      "border-radius": "10px",

                                      "background": "white",
                                      height: props && props.couponReward && props.couponReward.type == "cashback" ? "123px" : "37px",
                                      marginBottom: "50%",
                                    }}
                                  >
                                    <div
                                      className="styles_slide__2c207"
                                      style={{ marginRight: 0 }}
                                    >
                                      <div>
                                        <div
                                          className="styles_cardWithPadding__JE1QE"
                                          data-testid="home-restaurant-card-wrapper"
                                          style={{
                                            width:
                                              "calc((100vw - 0px) - 12px)",
                                          }}
                                        >
                                          <a
                                            data-testid="resturant-card-anchor-container"
                                            className="styles_container__fLC0R"
                                            aria-label="Restaurant name: Bakingo, 
Cuisines: Bakery, Desserts, Beverages, Snacks,
Area: Rohini,
3.0 km away,
Rating: 4.4,
Delivers in: 25 mins,
Cost is: RUPEES 300 for two,


Double tap to open restaurant menu."
                                            tabIndex={0}
                                            role="button"
                                          >

                                            <div
                                              style={{
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                "align-items": "center",
                                                "margin-right": "28px",
                                                marginTop: "10px",
                                              }}
                                            >
                                              <h2
                                                style={{
                                                  "font-family": "Roboto",
                                                  "font-size": "14px",
                                                  "font-style": "normal",
                                                  "font-weight": "600",
                                                  "line-height":
                                                    "150%" /* 21px */,
                                                  "letter-spacing": "0.2px",
                                                  color: "#384F6F"

                                                }}
                                              >
                                                Grand Total
                                              </h2>
                                              <h2
                                                style={{
                                                  "font-family": "Roboto",
                                                  "font-size": "14px",
                                                  "font-style": "normal",
                                                  "font-weight": "600",
                                                  "line-height":
                                                    "150%" /* 21px */,
                                                  "letter-spacing": "0.2px",
                                                  color: "#384F6F"
                                                }}
                                              >
                                                ₹{" "}
                                                {props && props.comboCart && ((props && props.comboCart && props.comboCart.totalPrice && props.comboCart.totalPrice) * (props && props.comboCart && props.comboCart && props.comboCart.count)).toFixed(2)}
                                                {finalAmountGrandDiscount && (finalAmountGrandDiscount).toFixed(2)}
                                              </h2>


                                            </div>
                                          </a>
                                        </div>


                                      </div>
                                    </div>
                                  </div>}
                                  {props.clientId ? (
                                    <div
                                      style={{
                                        position: "fixed",
                                        bottom: `-15px`,
                                        "margin-left": "-8px",
                                        width: "100%"
                                      }}
                                    >
                                      <div
                                        className="styles_row__1ivP1 shadow-box"
                                        data-testid="grid-row"
                                        style={{

                                          "margin-bottom": "15px",
                                          height: "129px",
                                          "border-top-right-radius": "11px",
                                          "border-top-left-radius": "11px",


                                          "border-radius": "20px 20px 0px 0px",
                                          background: "#FFF",
                                          "box-shadow": "0px 0px 24px 0px rgba(0, 0, 0, 0.08)"
                                        }}
                                      >


                                        <div
                                          className="styles_cardWithPadding__JE1QE"

                                          style={{
                                            width: "100%"
                                          }}
                                        >


                                          <div style={{ width: "94%", padding: "5%" }}>
                                            <div
                                              style={{
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",

                                              }}
                                            >
                                              <div style={{ display: "flex", }}>
                                                {localStorage.getItem("defaultPgName") == "WALLET" && <div style={{ display: "flex", alignItems: "center", marginRight: "13px" }}> <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "35px", height: "35px", border: "1px solid rgba(148, 163, 184, 0.5)", borderRadius: "5px" }}><img src={bpPg} style={{ height: "27x", height: "27px" }} /></div></div>}
                                                {localStorage.getItem("defaultPgName") == "WALLET_LOYALTY" && <div style={{ display: "flex", alignItems: "center", marginRight: "13px" }}> <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "35px", height: "35px", border: "1px solid rgba(148, 163, 184, 0.5)", borderRadius: "5px" }}><img src={dpPg} style={{ height: "27x", height: "27px" }} /></div></div>}
                                                {localStorage.getItem("defaultPgName") == "SODEXO" && <div style={{ display: "flex", alignItems: "center", marginRight: "13px" }}> <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "35px", height: "35px", border: "1px solid rgba(148, 163, 184, 0.5)", borderRadius: "5px" }}><img src={pluxee} style={{ height: "27x", height: "27px" }} /></div></div>}

                                                {(localStorage.getItem("defaultPgName") == "PAYTM") && <div style={{ display: "flex", alignItems: "center", marginRight: "13px" }}> <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "35px", height: "35px", border: "1px solid rgba(148, 163, 184, 0.5)", borderRadius: "5px" }}><img src={paytm} style={{ height: "27x", height: "27px" }} /></div></div>}
                                                {(localStorage.getItem("defaultPgName") == "R_WALLET") && <div style={{ display: "flex", alignItems: "center", marginRight: "13px" }}> <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "35px", height: "35px", border: "1px solid rgba(148, 163, 184, 0.5)", borderRadius: "5px" }}><img src={r_card} style={{ height: "27x", height: "27px" }} /></div></div>}
                                                {(localStorage.getItem("defaultPgName") == "R_CARD") && <div style={{ display: "flex", alignItems: "center", marginRight: "13px" }}> <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "35px", height: "35px", border: "1px solid rgba(148, 163, 184, 0.5)", borderRadius: "5px" }}><img src={card} style={{ height: "27x", height: "27px" }} /></div></div>}



                                                <div>
                                                  <h2
                                                    style={{
                                                      color: "#384F6F",

                                                      /* SM14 */
                                                      "font-family": "Roboto",
                                                      "font-size": "14px",
                                                      "font-style": "normal",
                                                      "font-weight": "600",
                                                      "line-height": "150%", /* 21px */
                                                      "letter-spacing ": "0.2px"
                                                    }}
                                                  >
                                                    Payment Method
                                                  </h2>
                                                  <p
                                                    style={{
                                                      fontSize: "14px",
                                                    }}
                                                  >
                                                    {" "}
                                                    {defaultPgName ==
                                                      "PAYTM" &&
                                                      "Paytm Wallet"}
                                                    {defaultPgName ==
                                                      "WALLET_LOYALTY" &&
                                                      "Daalchini Points"}
                                                    {defaultPgName ==
                                                      "WALLET" &&
                                                      "Business Payments"}
                                                    {defaultPgName ==
                                                      "SODEXO" &&
                                                      "Pluxee"}
                                                    {defaultPgName ==
                                                      "RAZORPAY" &&
                                                      "Razorpay"}
                                                    {defaultPgName ==
                                                      "R_CARD" &&
                                                      "Debit/Credit Card "}{" "}
                                                    {defaultPgName ==
                                                      "R_UPI" && "UPI"}
                                                    {defaultPgName ==
                                                      "R_WALLET" &&
                                                      "Wallet"}
                                                  </p>
                                                </div>
                                              </div>
                                              {
                                                <div
                                                  style={{
                                                    "text-decoration":
                                                      "none",
                                                    marginRight: "-20px"

                                                  }}
                                                  onClick={props.goToPaymentOption}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      "align-items":
                                                        "center",
                                                    }}
                                                  >
                                                    <h3
                                                      style={{
                                                        fontSize:
                                                          "13px",
                                                        color:
                                                          "#718198",
                                                      }}
                                                    >
                                                      Change
                                                    </h3>
                                                    <img
                                                      style={{
                                                        "margin-left":
                                                          "5px",
                                                      }}
                                                      src={changeArrow}
                                                    />
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                            <div
                                              style={{
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",

                                                "align-items": "center",
                                              }}
                                            >
                                              <div>
                                                <h3
                                                  style={{
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  Total Amount
                                                </h3>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >

                                                  {console.log(
                                                    "props.distotalAmount",
                                                    props.distotalAmount
                                                  )}
                                                  {!props.distotalAmount ? (
                                                    <h2
                                                      style={{
                                                        fontSize:
                                                          "18px",
                                                      }}
                                                    >




                                                      {!(props && props.comboCart == null) && <>
                                                      <span style={{  }}>₹ &nbsp;{props && props.comboCart && ((props && props.comboCart && props.comboCart.totalPrice && props.comboCart.totalPrice) * (props && props.comboCart && props.comboCart && props.comboCart.count)).toFixed(2)}</span></>}
                                                      {(props && props.comboCart == null) && props && props.couponReward && props.couponReward.type === "discount" ? (
                                                        <span>₹ &nbsp;{finalAmountGrandDiscount && finalAmountGrandDiscount.toFixed(2)}</span>
                                                      ) : (
                                                        <>
                                                          {(props && props.comboCart == null) && <>₹ &nbsp;{finalAmountGrand && finalAmountGrand.toFixed(2)}</>}
                                                        </>
                                                      )}

                                                    </h2>
                                                  ) : (
                                                    <h2
                                                      style={{
                                                        textDecoration:
                                                          "line-through",
                                                        color:
                                                          "#8d97a1",


                                                        "font-family": "Roboto",
                                                        "font-size": "18px",
                                                        "font-style": "normal",
                                                        "font-weight": "700",
                                                        "line-height": "normal"
                                                      }}
                                                    >
                                                      ₹{""}{" "}
                                                      {
                                                        props.totalAmount.toFixed(2)
                                                      }
                                                    </h2>
                                                  )}

                                                  {!props.distotalAmount ? (
                                                    <h2>

                                                    </h2>
                                                  ) : (
                                                    <h2 style={{
                                                      color: "#384F6F",

                                                      "font-family": "Roboto",
                                                      "font-size": "18px",
                                                      "font-style": "normal",
                                                      "font-weight": "700",
                                                      "line-height": "normal"
                                                    }}>
                                                      {" "}
                                                      ₹{""}{" "}
                                                      {
                                                        props && props.couponReward && props.couponReward.type == "discount" ? finalAmountGrandDiscount && finalAmountGrandDiscount.toFixed(2) : finalAmountGrand && finalAmountGrand

                                                      }
                                                    </h2>
                                                  )}
                                                </div>
                                              </div>
                                              <div>
                                                <div
                                                  style={{
                                                    "align-items":
                                                      "center",
                                                    display: "flex",
                                                    marginTop: "10px",
                                                  }}
                                                >
                                                  <button
                                                    onClick={(e) => {
                                                      completeOrder(e, finalAmountGrandDiscount)
                                                    }
                                                    }
                                                    style={{
                                                      backgroundColor:
                                                        "rgb(0, 177, 119)",
                                                      color: "white",
                                                      padding: "13px",
                                                      fontSize: "14px",
                                                      "border-radius":
                                                        "12px",
                                                      marginRight:
                                                        "-27px",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        "align-items":
                                                          "center",


                                                      }}
                                                    >
                                                      <div>
                                                        Place Order
                                                      </div>
                                                      <img
                                                        style={{
                                                          "margin-left":
                                                            "5px",
                                                        }}
                                                        src={proArrow}
                                                      />
                                                    </div>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                        </div>
                                        <div />

                                      </div>
                                    </div>
                                  ) :
                                    (
                                      <div
                                        style={{
                                          position: "fixed",
                                          bottom: `-15px`,
                                          "margin-left": "-14px",
                                        }}
                                      >
                                        <div
                                          className="styles_row__1ivP1 shadow-box"
                                          data-testid="grid-row"
                                          style={{
                                            marginTop: "4%",
                                            "margin-right": "12px",
                                            "margin-left": "10px",
                                            "margin-bottom": "13px",
                                            height: "129px",
                                            background: "white",
                                            "border-top-right-radius": "11px",
                                            "border-top-left-radius": "11px",
                                          }}
                                        >
                                          <div
                                            className="styles_slide__2c207"
                                            style={{ marginRight: 0 }}
                                          >
                                            <div>
                                              <div
                                                className="styles_cardWithPadding__JE1QE"
                                                data-testid="home-restaurant-card-wrapper"
                                                style={{
                                                  width:
                                                    "calc((100vw - 0px) - 12px)",
                                                }}
                                              >
                                                <a
                                                  data-testid="resturant-card-anchor-container"
                                                  className="styles_container__fLC0R"
                                                  aria-label="Restaurant name: Bakingo, 
Cuisines: Bakery, Desserts, Beverages, Snacks,
Area: Rohini,
3.0 km away,
Rating: 4.4,
Delivers in: 25 mins,
Cost is: RUPEES 300 for two,


Double tap to open restaurant menu."
                                                  tabIndex={0}
                                                  role="button"
                                                >
                                                  <div
                                                    className="styles_imgContainer__1uHo5"
                                                    aria-hidden="true"
                                                  ></div>
                                                  <div>
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        "justify-content":
                                                          "space-between",

                                                      }}
                                                    >

                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        "justify-content":
                                                          "space-between",

                                                        "align-items": "center",
                                                        marginTop: "10%"
                                                      }}
                                                    >
                                                      <div>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                          }}
                                                        >
                                                          <h3
                                                            style={{
                                                              color: "#384F6F",
                                                            }}
                                                          >
                                                            Almost There
                                                          </h3>
                                                        </div>
                                                        <p
                                                          style={{
                                                            fontSize: "11px",
                                                            color: "#718198",
                                                          }}
                                                        >
                                                          Login or Signup to
                                                          place your order
                                                        </p>
                                                      </div>
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            "rgb(0, 177, 119)",
                                                          color: "white",
                                                          padding: "15px",
                                                          fontSize: "14px",
                                                          "border-radius":
                                                            "17px",
                                                          marginRight: "-5px",
                                                          width: "40%",
                                                          textDecoration:
                                                            "none",
                                                        }}
                                                        onClick={(e) => {
                                                          props.LoginFLagFun(e);
                                                        }}
                                                      >
                                                        <h3
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          LOGIN
                                                        </h3>
                                                      </button>
                                                    </div>
                                                  </div>
                                                </a>
                                              </div>
                                              <div />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                </Box>

                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </Box>

                </>
              )
              /*  :<><NotFoundPage/></> */
            }
          </>
        ) : (
          <>
            {props.loader && <WaitingLoder />}
            {props.login && (


              <>
                {localStorage.getItem('Guest_clientId') && <h1 style={{
                  position: "fixed",
                  "top": "25px",
                  left: "30px",

                  "border-radius": "27px",
                  background: "rgba(0, 0, 0, 0.62)",


                  color: "#FFF",
                  "text-align": "center",
                  "font-family": "Roboto",
                  "font-size": "12px",
                  "font-style": "normal",
                  "font-weight": "500",
                  "line-height": "28px",

                  "padding": "5px",

                  width: "20%", "text-align": "center",
                  display: "flex", width: "66px",
                  height: "25px", "padding": "10px",
                  "flex-direction": "column",
                  "justify-content": "center",
                  "align-items": "center",
                  gap: "10px", "flex-shrink": "0"


                }} onClick={(e) => { props.GuestBack() }}>Back</h1>}
                <div style={{}}>
                  <img src={loginBackground} />
                </div>
                <div style={{ padding: "33px" }}>
                  <div className="a-accordion-row-a11y">
                    <h3
                      style={{
                        margin: "15px",
                        "text-align": "center",
                        color: "#384F6F",
                      }}
                    >
                      India's First 24*7 Instant Automated Store
                    </h3>
                    <p className="hr" style={{ "margin-top": "46px" }}>
                      <span className="hrspan">Login</span>
                    </p>
                  </div>
                  <div className="a-accordion-inner">
                    <div
                      className="auth-validate-form fwcim-form auth-clearable-form"
                      style={{ marginTop: "15%" }}
                    >
                      <div className="a-input-text-group a-spacing-medium a-spacing-top-micro">
                        <div className="a-row a-spacing-base">
                          <span className="a-declarative">
                            <div className="a-input-text-wrapper auth-required-field auth-fill-claim ">
                              <div
                                className="a-section country-picker aok-hidden"
                                style={{ display: "none" }}
                              >
                                <span className="a-declarative">
                                  <span className="country-display-text">
                                    IN +91
                                  </span>
                                </span>
                              </div>

                              <div className="inputWithIcon">
                                <input
                                  className="hello"
                                  type="text"
                                  placeholder="Your Mobile Number"
                                  onChange={(e) => {
                                    props.onchangeMobile(e);
                                  }}
                                />
                                <i
                                  style={{
                                    "margin-top": "11px",
                                    "margin-left": "4%",
                                  }}
                                >
                                  <img style={{ width: "40%" }} src={keypad} />
                                </i>
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                      {props.mobile.length == 10 ? (
                        <div className="a-section">
                          <div className="a-button-stack">
                            <span
                              id="continue"
                              className={"continue a-button-span12"}
                            >
                              <span
                                className="a-button-inner"
                                style={{
                                  backgroundColor: "rgb(0, 177, 119)",
                                  color: "white",
                                }}
                              >
                                <button
                                  className="a-button-input"
                                  onClick={props.LoginApi}
                                  style={{
                                    backgroundColor: "rgb(0, 177, 119)",
                                    color: "white",
                                  }}
                                />
                                <span
                                  className="a-button-text"
                                  style={{
                                    fontSize: "16px",
                                    backgroundColor: "#00B177",
                                    color: "white",
                                  }}
                                >
                                  Submit
                                </span>
                              </span>
                            </span>
                            <div className="a-section a-spacing-medium">
                              <a
                                style={{ textDecoration: "none" }}
                                href="https://www.daalchini.co.in/terms.html"
                              >
                                {" "}
                                <div
                                  id="legalTextRow"
                                  className="a-row a-spacing-top-medium a-size-small"
                                  style={{
                                    "margin-top": "22%",
                                    "text-align": "center",
                                    fontSize: "12px",
                                  }}
                                >
                                  <span style={{ color: "#718198" }}>
                                    By continuing, you agree to our{" "}
                                  </span>
                                  <span style={{ color: "#583C43" }}>
                                    Terms of Service
                                    <span style={{ color: "#718198" }}>and</span>{" "}
                                    Privacy Policy.
                                  </span>
                                </div>
                              </a>
                            </div>
                          </div>
 
                        </div>
                      ) : (
                        <div className="a-section">
                          <div className="a-button-stack">
                            <span
                              id="continue"
                              className={
                                "a-button a-button-span12 a-button-primary"
                              }
                            >
                              <span
                                className="a-button-inner"
                                style={{
                                  backgroundColor: "rgb(0, 177, 119)",
                                  color: "white",
                                }}
                              >
                                <button
                                  className="a-button-input"
                                  style={{
                                    backgroundColor: "rgb(0, 177, 119)",
                                    color: "white",
                                  }}
                                />
                                <span
                                  className="a-button-text"
                                  style={{
                                    fontSize: "16px",
                                    "background-color": "#BCBDBD",
                                    color: "white",
                                  }}
                                >
                                  Submit
                                </span>
                              </span>
                            </span>
                            <p style={{textAlign:"center",padding:"2%",fontSize:"4vw"}}> or</p>

                            <GoogleLogin
                  //onClick={(e)=>{Loading(e)}}
            clientId="79634458363-nhi15g8c5sdoa24bm8pp5c0ooc4fps7i.apps.googleusercontent.com" //TO BE CREATED
            render={renderProps => (<>

      <button
                className="button"
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
                style={{    textAlign: "center",
                  padding: "5%",
                  border: "2px solid #80808087",
                  borderRadius:"5px",
                  width:"100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems:"center"
              }}
              >
                           <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.64 9.20443C17.64 8.56625 17.5827 7.95262 17.4764 7.36353H9V10.8449H13.8436C13.635 11.9699 13.0009 12.9231 12.0477 13.5613V15.8194H14.9564C16.6582 14.2526 17.64 11.9453 17.64 9.20443Z" fill="#4285F4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5613C11.2418 14.1013 10.2109 14.4204 9 14.4204C6.65591 14.4204 4.67182 12.8372 3.96409 10.71H0.957275V13.0418C2.43818 15.9831 5.48182 18 9 18Z" fill="#34A853"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.96409 10.7101C3.78409 10.1701 3.68182 9.59325 3.68182 9.00007C3.68182 8.40689 3.78409 7.83007 3.96409 7.29007V4.95825H0.957273C0.347727 6.17325 0 7.5478 0 9.00007C0 10.4523 0.347727 11.8269 0.957273 13.0419L3.96409 10.7101Z" fill="#FBBC05"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z" fill="#EA4335"/>
</svg>
          <span style={{marginLeft:"5%"}}>Log in with Google</span> 
              </button>
              </>
            )}
            onSuccess={props&&props.responseGoogle}
            onFailure={props&&props.responseGoogle}
          />
                            <div className="a-section a-spacing-medium">
                              <a
                                style={{ textDecoration: "none" }}
                                href="https://www.daalchini.co.in/terms.html"
                              >
                                {" "}
                                <div
                                  id="legalTextRow"
                                  className="a-row a-spacing-top-medium a-size-small"
                                  style={{
                                    "margin-top": "22%",
                                    "text-align": "center",
                                    fontSize: "12px",
                                  }}
                                >
                                  <span style={{ color: "#718198" }}>
                                    By continuing, you agree to our{" "}
                                  </span>
                                  <span style={{ color: "#583C43" }}>
                                    Terms of Service{" "}
                                    <span style={{ color: "#718198" }}>and</span>{" "}
                                    Privacy Policy.
                                  </span>
                                </div>
                              </a>
                              
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
        
                </div>
              </>


            )}
            {props.loginOtp && (
              <>



                <img style={{}} src={loginBackground} />

                <div style={{ padding: "33px" }}>
                  <div className="a-accordion-inner">
                    <div className="auth-validate-form fwcim-form auth-clearable-form">
                      <div className="a-input-text-group a-spacing-medium a-spacing-top-micro">
                        <div className="a-row a-spacing-base">
                          <span className="a-declarative">
                            <div className="a-input-text-wrapper auth-required-field auth-fill-claim ">
                              <div
                                className="a-section country-picker aok-hidden"
                                style={{ display: "none" }}
                              >
                                <span className="a-declarative"></span>
                              </div>
                              <h3
                                style={{
                                  margin: "15px",
                                  "text-align": "center",
                                  color: "#384F6F",
                                }}
                              >
                                India's First 24*7 Instant Automated Store
                              </h3>

                              <div style={{ marginTop: "20%" }}>
                                <p
                                  className="hr"
                                  style={{ "margin-bottom": "50px" }}
                                >
                                  <span className="hrspan">OTP</span>
                                </p>

                                <div className="inputWithIcon">


                                  <input className="hello" maxLength={4} type="text" placeholder="ENTER OTP" onChange={(e) => { props.onchangeOtp(e) }} onInput={(e) => { props.setOtp(e.target.value) }} onPaste={(e) => { props.setOtp(e.clipboardData.getData("text")) }} />

                                  <i
                                    style={{
                                      "margin-top": "15px",
                                      "margin-left": "4%",
                                    }}
                                  >
                                    <img
                                      style={{ width: "50%" }}
                                      src={otpkeyicon}
                                    />
                                  </i>
                                </div>
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                      {console.log("PASTEWALa", props.otp)}
                      {props.otpFlag && props.otp.length == 4 ? (
                        <div className="a-section">
                          <div className="a-button-stack">
                            <span
                              id="continue"
                              className={"continue a-button-span12"}
                            >
                              <span className="a-button-inner">
                                <button
                                  id="continue"
                                  className="a-button-input"
                                  onClick={props.SubmitOTP}
                                />
                                <span
                                  style={{ color: "white", fontSize: "16px" }}
                                  className="a-button-text"
                                >
                                  Verify
                                </span>
                              </span>
                            </span>
                            <div className="a-section a-spacing-medium"></div>
                          </div>
                        </div>
                      ) : (
                        <div className="a-section">
                          <div className="a-button-stack">
                            <span
                              id="continue"
                              className="a-button a-button-span12 a-button-primary"
                            >
                              <span className="a-button-inner">
                                <input id="continue" className="a-button-input" />
                                <span
                                  className="a-button-text"
                                  style={{
                                    fontSize: "16px",
                                    "background-color": "rgb(188, 189, 189)",
                                    color: "white",
                                  }}
                                >
                                  Verify
                                </span>
                              </span>
                            </span>
                            <div className="a-section a-spacing-medium"></div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>

            )}
          </>
        )}
      </Box>
    </>
  );
}

export default Mycart;
